import { Howl } from "howler";
import { Sounds } from "../../types";
import store from "../store";

export default class Sound {
  private static sounds: Record<string, Howl> = {};

  static preload(sounds: Sounds[] = Object.values(Sounds)) {
    sounds.forEach((sound) => Sound.getHowl(sound));
  }

  static play(sound: Sounds) {
    const howl = Sound.getHowl(sound);

    if (howl.state() === "loaded") {
      howl.play();
    } else {
      howl.once("load", () => howl.play());
      howl.load();
    }
  }

  private static getHowl(sound: Sounds) {
    const url = `${
      store.getState().application.bizzeySetting.api_base
    }audio/${sound}`;

    if (!Sound.sounds[url]) {
      Sound.sounds[url] = new Howl({
        src: [url],
        preload: true,
      });
    }

    return Sound.sounds[url];
  }
}
